import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

import { WIZARD_PROGRESS } from '../../lib/constants';

const SubstepRow = ({ substep, isLastInTree, onClick, isHidden }) => {
  if (isHidden) return null;

  const isActive = Boolean(substep.active);
  const isCompleted = substep.status === WIZARD_PROGRESS.COMPLETED;

  return (
    <li onClick={onClick} className="relative flex cursor-pointer items-center gap-2">
      {!isLastInTree && <div className="absolute left-2.5 top-full h-6 w-px bg-neutral-200" />}

      <div
        className={cn(
          'relative z-10 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-white',
          isCompleted
            ? 'border-4 border-solid border-success-100'
            : isActive
              ? 'border-4 border-solid border-primary-100'
              : 'border-4 border-solid border-neutral-200'
        )}>
        <div
          className={cn(
            'h-1.5 w-1.5 rounded-full',
            isCompleted ? 'bg-success-500' : isActive ? 'bg-primary-500' : 'bg-neutral-500'
          )}
        />
      </div>

      <div className="min-w-0 flex-1">
        <h4
          className={cn(
            'select-none text-xs font-medium leading-snug',
            isActive && 'font-semibold',
            isActive ? (isCompleted ? 'text-success-600' : 'text-primary-500') : 'text-neutral-500'
          )}>
          {substep.name}
        </h4>
      </div>

      {isCompleted && (
        <div className="flex-shrink-0">
          <Icon icon="check-thick-linear" color="success" />
        </div>
      )}
    </li>
  );
};

export default SubstepRow;
